/* eslint-disable @typescript-eslint/no-invalid-void-type */
import { apiSlice } from './apiSlice';
import { SellerCategory, VolumeOfPotential, YardType } from '../../core/models/Seller';
import FuelType from '../../core/models/FuelType';
import Transmission from '../../core/models/Transmission';
import VehicleCategory from '../../core/models/VehicleCategory';
import VehicleMake from '../../core/models/VehicleMake';
import VehicleModel from '../../core/models/VehicleModel';
import VehicleGrade from '../../core/models/VehicleGrade';
import VehicleColor from '../../core/models/VehicleColor';
import VehicleCylinder from '../../core/models/VehicleCylinder';
import VehicleCondition from '../../core/models/VehicleCondition';
import VehicleType from '../../core/models/VehicleType';
import VehicleLocation from '../../core/models/VehicleLocation';
import { BuyerCategory } from '../../core/models/Buyer';

export const commonApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getVehicleMakes: builder.query<VehicleMake[], void>({
            query: () => "/make",
            keepUnusedDataFor: 60,
            providesTags: (result, error, id) => [{ type: 'Common', id: 'LIST' }],
        }),
        getVehicleModels: builder.query<VehicleModel[], void>({
            query: () => "/models",
            providesTags: (result, error, id) => [{ type: 'Common', id: 'LIST' }],
        }),
        getVehicleGrades: builder.query<VehicleGrade[], void>({
            query: () => "/grades",
            providesTags: (result, error, id) => [{ type: 'Common', id: 'LIST' }],
        }),
        getVehicleColors: builder.query<VehicleColor[], void>({
            query: () => "/colors",
            providesTags: (result, error, id) => [{ type: 'Common', id: 'LIST' }],
        }),
        getVehicleCylinders: builder.query<VehicleCylinder[], void>({
            query: () => "/cylinders",
            providesTags: (result, error, id) => [{ type: 'Common', id: 'LIST' }],
        }),
        getVehicleConditions: builder.query<VehicleCondition[], void>({
            query: () => "/vehicleConditions",
            providesTags: (result, error, id) => [{ type: 'Common', id: 'LIST' }],
        }),
        getVehicleTypes: builder.query<VehicleType[], void>({
            query: () => "/vehicleTypes",
            providesTags: (result, error, id) => [{ type: 'Common', id: 'LIST' }],
        }),
        getVehicleLocation: builder.query<VehicleLocation[], void>({
            query: () => "/locations",
            providesTags: (result, error, id) => [{ type: 'Common', id: 'LIST' }],
        }),
        getVehicleCategories: builder.query<VehicleCategory[], void>({
            query: () => "/vehicleCategories",
            providesTags: (result, error, id) => [{ type: 'Common', id: 'LIST' }],
        }),
        getFuelTypes: builder.query<FuelType[], void>({
            query: () => "/FuelTypes",
            providesTags: (result, error, id) => [{ type: 'Common', id: 'LIST' }],
        }),
        getTransmissions: builder.query<Transmission[], void>({
            query: () => "/TransmissionTypes",
            providesTags: (result, error, id) => [{ type: 'Common', id: 'LIST' }],
        }),
        getSellerCategories: builder.query<SellerCategory[], void>({
            query: () => "/SellerCategories",
            providesTags: (result, error, id) => [{ type: 'Common', id: 'LIST' }],
        }),
        getBuyerCategories: builder.query<BuyerCategory[], void>({
            query: () => "/BuyerCategories",
            providesTags: (result, error, id) => [{ type: 'Common', id: 'LIST' }],
        }),
        getYardTypes: builder.query<YardType[], void>({
            query: () => "/YardTypes",
            providesTags: (result, error, id) => [{ type: 'Common', id: 'LIST' }],
        }),
        getVolumeOfPotential: builder.query<VolumeOfPotential[], void>({
            query: () => "/VolumeOfPotentials",
            providesTags: (result, error, id) => [{ type: 'Common', id: 'LIST' }],
        }),
    }),
});

export const {
    useGetVehicleMakesQuery,
    useGetVehicleModelsQuery,
    useGetVehicleGradesQuery,
    useGetVehicleColorsQuery,
    useGetVehicleCylindersQuery,
    useGetVehicleConditionsQuery,
    useGetVehicleTypesQuery,
    useGetVehicleLocationQuery,
    useGetVehicleCategoriesQuery,
    useGetSellerCategoriesQuery,
    useGetBuyerCategoriesQuery,
    useGetYardTypesQuery,
    useGetVolumeOfPotentialQuery
} = commonApiSlice;